import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowLastSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 6.414 11.586 12 6 17.586 7.414 19l7-7-7-7L6 6.414ZM18 5h-2v14h2V5Z"
    />
  </svg>
);
export default IconArrowLastSizeM;
